import t from "../../theme";

export const useGetSignup1Styles = () => {
  return {
    container: {
      width: "92%",
      maxWidth: 420,
      display: "flex",
      flexDirection: "column",
      gap: 18,
      position: "relative",
      zIndex: 1,
      alignItems: "center",
    },
    card: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      padding: "22px 20px",
      borderRadius: "22px",
      background: "transparent",
      border: "none",
      boxShadow: "none",
      color: t.brand.white,
    },
    title: {
      margin: 0,
      fontSize: "26px",
      lineHeight: 1.2,
      fontWeight: 700,
      textAlign: "center",
      color: t.brand.white,
    },
    providerRow: {
      width: "100%",
      display: "flex",
    },
    providerButton: {
      width: "100%",
      minHeight: 44,
      borderRadius: 999,
      padding: "10px 12px",
      backgroundColor: "rgba(255,255,255,0.18)",
      color: t.brand.white,
      fontWeight: 600,
      fontSize: "14px",
      textTransform: "none",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.24)",
        boxShadow: "none",
      },
      "&.Mui-disabled": {
        opacity: 0.7,
        color: "rgba(255,255,255,0.8)",
      },
      "& .MuiButton-startIcon": {
        marginRight: 8,
      },
    },
    providerIcon: {
      width: 18,
      height: 18,
      display: "block",
    },
    loadingOverlayContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 16,
    },
    loaderSpinner: {
      width: 56,
      height: 56,
      position: "relative",
      animation: "signup1-loader-rotate 1.1s linear infinite",
      "@keyframes signup1-loader-rotate": {
        from: {
          transform: "rotate(0deg)",
        },
        to: {
          transform: "rotate(360deg)",
        },
      },
    },
    loaderDot: {
      position: "absolute",
      width: 10,
      height: 10,
      borderRadius: "50%",
      opacity: 0.18,
      boxShadow: "0 0 0 2px rgba(255,255,255,0.24)",
    },
    loaderDot1: {
      top: 0,
      left: "50%",
      marginLeft: -5,
      opacity: 1,
      background: "#00ADEF",
    },
    loaderDot2: {
      top: 8,
      right: 8,
      opacity: 0.88,
      background: "#50AB32",
    },
    loaderDot3: {
      top: "50%",
      right: 0,
      marginTop: -5,
      opacity: 0.76,
      background: "#EA9A01",
    },
    loaderDot4: {
      right: 8,
      bottom: 8,
      opacity: 0.64,
      background: "#50AB32",
    },
    loaderDot5: {
      bottom: 0,
      left: "50%",
      marginLeft: -5,
      opacity: 0.52,
      background: "#00ADEF",
    },
    loaderDot6: {
      bottom: 8,
      left: 8,
      opacity: 0.4,
      background: "#EA9A01",
    },
    loaderDot7: {
      top: "50%",
      left: 0,
      marginTop: -5,
      opacity: 0.28,
      background: "#50AB32",
    },
    loaderDot8: {
      top: 8,
      left: 8,
      opacity: 0.2,
      background: "#EA9A01",
    },
    loadingOverlayTitle: {
      margin: 0,
      fontSize: "24px",
      lineHeight: 1.2,
      fontWeight: 700,
      color: "#173321",
      textAlign: "center",
    },
    loadingOverlayText: {
      margin: 0,
      fontSize: "13px",
      lineHeight: 1.6,
      color: "#486257",
      maxWidth: 260,
      textAlign: "center",
    },
    divider: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      color: "rgba(255,255,255,0.86)",
      fontSize: "13px",
      justifyContent: "center",
      "&::before": {
        content: '""',
        flex: 1,
        height: 1,
        background: "rgba(255,255,255,0.35)",
      },
      "&::after": {
        content: '""',
        flex: 1,
        height: 1,
        background: "rgba(255,255,255,0.35)",
      },
    },
    dividerText: {
      whiteSpace: "nowrap",
    },
    manualForm: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 12,
    },
    verificationPanel: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 14,
    },
    verificationHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "10px 12px",
      borderRadius: "16px",
      background: "rgba(255,255,255,0.12)",
      border: "1px solid rgba(255,255,255,0.16)",
    },
    emailPill: {
      minWidth: 0,
      fontSize: "15px",
      fontWeight: 600,
      color: t.brand.white,
      overflowWrap: "anywhere",
    },
    changeEmailButton: {
      border: "none",
      background: "transparent",
      color: "#d8f3dc",
      fontSize: "14px",
      fontWeight: 700,
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      cursor: "pointer",
      padding: 0,
      flexShrink: 0,
    },
    verificationCopy: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      alignItems: "center",
    },
    verificationTitle: {
      margin: 0,
      fontSize: "26px",
      lineHeight: 1.25,
      textAlign: "center",
      color: t.brand.white,
    },
    existingAccountCopy: {
      margin: 0,
      fontSize: "15px",
      lineHeight: 1.6,
      textAlign: "center",
      color: "rgba(255,255,255,0.86)",
    },
    otpFieldsWrapper: {
      display: "grid",
      gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      gap: 10,
      width: "100%",
      "@media (max-width: 420px)": {
        gap: 8,
      },
    },
    otpField: {
      width: "100%",
      aspectRatio: "1 / 1",
      borderRadius: "14px",
      border: "1px solid rgba(255,255,255,0.28)",
      background: "rgba(255,255,255,0.94)",
      color: "#184d2f",
      fontSize: "28px",
      fontWeight: 700,
      textAlign: "center",
      outline: "none",
      boxShadow: "0 12px 24px rgba(5, 35, 16, 0.12)",
      transition: "transform 0.16s ease, box-shadow 0.16s ease",
      "&:focus": {
        transform: "translateY(-1px)",
        boxShadow: "0 0 0 3px rgba(146, 214, 161, 0.34)",
      },
    },
    successBox: {
      padding: "14px 16px",
      borderRadius: "14px",
      background: "rgba(224, 244, 228, 0.96)",
      color: "#157347",
      textAlign: "center",
      fontSize: "15px",
      fontWeight: 700,
      lineHeight: 1.5,
    },
    verificationActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      flexWrap: "wrap",
    },
    rememberRow: {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      color: "rgba(255,255,255,0.92)",
      fontSize: "14px",
      cursor: "pointer",
      "& input": {
        width: 16,
        height: 16,
        margin: 0,
      },
    },
    resendLink: {
      border: "none",
      background: "transparent",
      color: "#d8f3dc",
      fontSize: "14px",
      fontWeight: 700,
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      cursor: "pointer",
      padding: 0,
      "&:disabled": {
        cursor: "not-allowed",
        opacity: 0.7,
      },
    },
    continueButton: {
      minHeight: 48,
      borderRadius: t.radius.md,
      background: t.green.gradient,
      color: t.brand.white,
      fontWeight: 600,
      fontSize: "16px",
      letterSpacing: "0.3px",
      textTransform: "none",
      boxShadow: t.shadow.brand,
      "&:hover": {
        background: t.green.dark,
        boxShadow: t.shadow.brandFocus,
      },
    },
    errorBox: {
      padding: "10px 12px",
      borderRadius: "12px",
      background: "rgba(220, 53, 69, 0.18)",
      border: "1px solid rgba(255,255,255,0.24)",
      color: "#fff3f3",
      fontSize: "13px",
      lineHeight: 1.5,
    },
    terms: {
      margin: 0,
      fontSize: "12px",
      lineHeight: 1.5,
      color: "rgba(255,255,255,0.82)",
      textAlign: "center",
    },
    inlineLink: {
      color: t.brand.white,
      textDecoration: "underline",
      textUnderlineOffset: "2px",
    },
    loginLink: {
      alignSelf: "center",
      padding: 0,
      minWidth: "auto",
      justifyContent: "center",
      color: "rgba(255,255,255,0.92)",
      textTransform: "none",
      fontWeight: 600,
      fontSize: "14px",
      textDecoration: "underline",
      textUnderlineOffset: "2px",
    },
  };
};
